var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.goTopShow),expression:"goTopShow"}],attrs:{"id":"goTop"}},[_c('a',{staticClass:"toTop",on:{"click":_vm.goTop}},[_c('i',{staticClass:"el-icon-caret-top"})])])}
var staticRenderFns = []

export { render, staticRenderFns }